module.exports = __webpack_public_path__ + "img/flowData.22357340.png";